export default __webpack_public_path__ + "static/media/ill.bf571309.png";